import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _PaginatedCollection;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import * as Immutable from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx } from '@instructure/emotion';
import Paginator from '../Paginator';
import Spinner from '../spinner/Spinner';

/**
 * Renders pagination controls and manages state of page contents. `getPage`
 * will be called with the page number and any collection parameters, and should
 * return a promise that resolves to `{ records, totalPages }`, where `records`
 * is an array of arbitrary records, and `totalPages` is the total number of
 * pages. `renderRecords` will be called with `records` as returned from the
 * `getPage` function. It is the responsibility of that function to render the
 * page.
 *
 * This component assumes that changing collection `params` can change the
 * underlying collection that is fetched. It thus resets the page cache when
 * `params` change.
 */

import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var PaginatedCollection = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_PaginatedCollection = /*#__PURE__*/function (_Component) {
  function PaginatedCollection() {
    var _this;
    _classCallCheck(this, PaginatedCollection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PaginatedCollection, [].concat(args));
    _defineProperty(_this, "onPageChange", function (nextPage) {
      _this.props.merge(_this.props.stateKey, {
        current: nextPage
      });
    });
    return _this;
  }
  _inherits(PaginatedCollection, _Component);
  return _createClass(PaginatedCollection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getPage(this.props.stateKey, this.props.currentPage, this.props.params);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var merge = _ref.merge,
        params = _ref.params,
        set = _ref.set,
        stateKey = _ref.stateKey;
      if (!params.equals(this.props.params)) {
        set(stateKey, Immutable.fromJS({
          current: 1
        }));
      } else if (stateKey !== this.props.stateKey) {
        merge(stateKey, {
          current: 1
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.getPage(this.props.stateKey, this.props.currentPage, this.props.params);
    }
  }, {
    key: "getPage",
    value: function () {
      var _getPage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(stateKey, page, params) {
        var _yield$this$props$get, records, totalPages;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.recordsLoaded(page)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return this.props.getPage(page, params);
            case 4:
              _yield$this$props$get = _context.sent;
              records = _yield$this$props$get.records;
              totalPages = _yield$this$props$get.totalPages;
              if (params.equals(this.props.params)) {
                this.props.merge(stateKey, {
                  contents: _defineProperty({}, page, records),
                  total: totalPages
                });
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getPage(_x, _x2, _x3) {
        return _getPage.apply(this, arguments);
      }
      return getPage;
    }()
  }, {
    key: "recordsLoaded",
    value: function recordsLoaded() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.currentPage;
      return this.props.contents.get(page.toString()) !== void 0;
    }
  }, {
    key: "renderRecords",
    value: function renderRecords() {
      var records = this.props.contents.get(this.props.currentPage.toString());
      if (records.size === 0 && this.props.empty) {
        return this.renderEmpty();
      }
      return this.props.renderRecords(records.toJS());
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      return jsx("div", {
        css: this.props.styles.empty
      }, this.props.empty);
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return jsx(Spinner, null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        currentPage = _this$props.currentPage,
        totalPages = _this$props.totalPages;
      return jsx(Paginator, {
        currentPage: currentPage,
        onPageChange: this.onPageChange,
        totalPages: totalPages
      }, this.recordsLoaded() ? this.renderRecords() : this.renderLoading());
    }
  }]);
}(Component), _defineProperty(_PaginatedCollection, "displayName", 'PaginatedCollection'), _defineProperty(_PaginatedCollection, "componentId", "Quizzes".concat(_PaginatedCollection.displayName)), _defineProperty(_PaginatedCollection, "propTypes", {
  currentPage: PropTypes.number.isRequired,
  contents: ImmutablePropTypes.map.isRequired,
  empty: PropTypes.node,
  getPage: PropTypes.func.isRequired,
  merge: PropTypes.func.isRequired,
  params: ImmutablePropTypes.map,
  renderRecords: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  stateKey: PropTypes.string.isRequired,
  totalPages: PropTypes.number.isRequired,
  styles: PropTypes.object
}), _defineProperty(_PaginatedCollection, "defaultProps", {
  empty: null,
  params: Immutable.Map()
}), _PaginatedCollection)) || _class);
export default PaginatedCollection;